import { getTestIds } from 'seagull/utils/TestIds';
export const GetCompletionToastTID = (parentTestId)=>getTestIds(parentTestId);
const { CompletionToastTID } = GetCompletionToastTID();
export const buildCompletionToastPayload = (transitions, texts)=>{
    if (transitions.length === 0) return null;
    const ready = transitions.filter((t)=>t.nextStatus === 'ready');
    const failed = transitions.filter((t)=>t.nextStatus === 'failed');
    if (transitions.length === 1) {
        var _ref;
        var _only_overrides;
        const only = transitions[0];
        if (only.nextStatus === 'ready') {
            var _ref1;
            var _only_overrides1;
            const action = only.downloadUrl != null ? {
                kind: 'open-url',
                url: only.downloadUrl,
                label: texts.toast.viewPdf(),
                biName: 'tasks_completion_toast_view_pdf'
            } : {
                kind: 'open-drawer',
                label: texts.toast.viewActivity(),
                biName: 'tasks_completion_toast_view_tasks_ready'
            };
            return {
                kind: 'success',
                message: (_ref1 = (_only_overrides1 = only.overrides) === null || _only_overrides1 === void 0 ? void 0 : _only_overrides1.ready) !== null && _ref1 !== void 0 ? _ref1 : texts.toast.singleReady({
                    name: only.agreementName
                }),
                action,
                testId: CompletionToastTID.Success()
            };
        }
        const retryRelationshipId = only.relationshipId;
        const action = retryRelationshipId != null ? {
            kind: 'retry',
            relationshipId: retryRelationshipId,
            previousJobId: only.jobId,
            label: texts.toast.retry(),
            biName: 'tasks_completion_toast_retry'
        } : {
            kind: 'open-drawer',
            label: texts.toast.viewActivity(),
            biName: 'tasks_completion_toast_view_tasks_failed'
        };
        return {
            kind: 'warning',
            message: (_ref = (_only_overrides = only.overrides) === null || _only_overrides === void 0 ? void 0 : _only_overrides.failed) !== null && _ref !== void 0 ? _ref : texts.toast.singleFailed({
                name: only.agreementName
            }),
            action,
            testId: CompletionToastTID.Warning()
        };
    }
    if (failed.length > 0) {
        return {
            kind: 'warning',
            message: texts.toast.manyFailed({
                count: failed.length
            }),
            action: {
                kind: 'open-drawer',
                label: texts.toast.viewActivity(),
                biName: 'tasks_completion_toast_view_tasks_failed'
            },
            testId: CompletionToastTID.Warning()
        };
    }
    return {
        kind: 'success',
        message: texts.toast.manyReady({
            count: ready.length
        }),
        action: {
            kind: 'open-drawer',
            label: texts.toast.viewActivity(),
            biName: 'tasks_completion_toast_view_tasks_ready'
        },
        testId: CompletionToastTID.Success()
    };
};
